// The two lists below mirror AUDITABLE_STATUSES_BY_TRIGGER in
// functions/functions/ai/service/auditor/logic.js, which is where they are enforced.
export const AUDITABLE_SESSION_ACTIVITY_TYPES = [
  'session',
  'supervision',
];

export const AUDITABLE_SESSION_ACTIVITY_STATUSES = [
  'pending-review',
  'pending-signatures',
  'closed',
  'rendered',
];

export const CHECKOUT_AUDITABLE_SESSION_ACTIVITY_STATUSES = [
  'in-progress',
  'finished',
  'pending-review',
  'pending-signatures',
];

function isAuditableType(sessionActivity) {
  return AUDITABLE_SESSION_ACTIVITY_TYPES.includes(sessionActivity?.type);
}

export function isSessionActivityAuditable(sessionActivity) {
  return isAuditableType(sessionActivity)
    && AUDITABLE_SESSION_ACTIVITY_STATUSES.includes(sessionActivity?.status);
}

export function isSessionActivityAuditableAtCheckout(sessionActivity) {
  return isAuditableType(sessionActivity)
    && CHECKOUT_AUDITABLE_SESSION_ACTIVITY_STATUSES.includes(sessionActivity?.status);
}
